import { inject, Injectable } from '@angular/core';
import { ProductDataModel } from '@libs/shop/models';
import { Observable } from 'rxjs';
import { ConnectorService } from '../connector';

@Injectable({ providedIn: 'root' })
export class LmivRepositoryService {
  private readonly connector: ConnectorService = inject(ConnectorService);

  public getProduct(productNumber: string): Observable<ProductDataModel> {
    return this.connector.connect<ProductDataModel>(
      'service',
      'lmiv',
      {
        pathParams: {
          productNumber,
        },
      },
    );
  }
}
